<template>
  <v-container class="component_main px-6">
    <v-row v-show="showList">
      <v-col>
        <h1>
          <v-badge
            light
            color="accent"
            class="black--text"
            :content="newMessagesCount"
            :value="newMessagesCount"
            >Notificações</v-badge
          >
        </h1>
        <p>Acesse as mensagens recebidas pelo sistema.</p>
      </v-col>
      <v-col
        class="d-flex justify-end  pr-6"
        v-if="addnotification"
      >
        <v-btn small height="30px" color="primary" depressed @click="selectToEditItem({}, true)"
          >Nova notificação</v-btn
        >
      </v-col>
    </v-row>
    <NotificationsForm
      v-show="!showList"
      :modules="modules"
      :close="
        (formData) => (formData ? saveItem(formData) : (showList = !showList))
      "
      :selectedItem="JSON.stringify(editItem)"
    />
    <v-row wrap class="d-flex flex-row">
      <v-col cols="12" sm="12" md="4" class="py-0">
        <NotificationsFilter
          v-show="showList"
          :modules="modules"
          :prestadores="prestadores"
          :importantMessagesCount="importantMessagesCount"
          :filterList="(item) => getNotifications({...payload, ...item})"
          :getList="(item) => getNotifications(item)"
          :permission="userData.Permissao"
        />
      </v-col>
      <v-col class="col-xs-12 col-sm-12 col-md-8 py-4">
        <NotificationsList
          v-show="showList"
          :modulosTitles="modulosTitles"
          :selectItem="(item, bool) => selectItem(item, bool)"
          :list="filteredList"
          :getList="(page) => getNotifications({...payload, offset: page})"
          :pagination="pagination"
        />
      </v-col>
      <!-- <v-col class="col-xs-12 col-sm-12 col-md-4">
        <NotificationsMessage
          :message="message"
          :updatenotification="updatenotification"
          :modulosTitles="modulosTitles"
          :selectItem="(item) => selectToEditItem(item, true)"
          v-show="showList && filteredList && filteredList.length"
          :markAsReaded="(item) => readedNotification(item)"
        />
      </v-col> -->
      
    </v-row>
    <NotificationsMessage
      :dialog="dialog"
      :close="() => dialog = false"
      :message="message"
      :updatenotification="updatenotification"
      :modulosTitles="modulosTitles"
      :selectItem="(item) => selectToEditItem(item, true)"
      v-show="showList && filteredList && filteredList.length"
      :markAsReaded="(item) => readedNotification(item)"
    />
    <Footer />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Footer from "@/components/common/Footer";
import NotificationsFilter from "@/components/notifications/Filter";
import NotificationsList from "@/components/notifications/List";
import NotificationsMessage from "@/components/notifications/Message";
import NotificationsForm from "@/components/notifications/Form";

export default {
  components: {
    Footer,
    NotificationsFilter,
    NotificationsList,
    NotificationsMessage,
    NotificationsForm,
  },
  data() {
    return {
      dialog: false,
      editItem: {},
      filter: null,
      filteredList: [],
      headers: [
        { text: "Nome", align: "start", value: "Nome" },
        { text: "Usuário", value: "UserName" },
        { text: "Email", value: "Email" },
        { text: "Perfis de acesso", value: "profiles" },
        { text: "Ações", value: "actions" },
      ],
      importantMessagesCount: null,
      modules: [],
      newMessagesCount: null,
      prestadores: [],
      showList: true,
      selectedItem: null,
      message:"",
      payload: {}
    }
  },
  watch: {
    list(val) {
      this.filteredList = val;
    },
    grupoEconomico: {
      deep: true,
      handler(val) {
        this.getNotifications({grupoEconomico: val})
      },
    },
    grupoEconomicoList: {
      deep: true,
      handler() {
        this.prestadores = this.$store.getters[
          "permissions/getPrestadoresByGeco"
        ]();
      },
    },
  },
  computed: {
    ...mapState({
      dashNotification:(state)=> state.notifications.dashNotification,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
      list:(state)=> state.notifications.list,
      pagination:(state)=> state.notifications.pagination,
      modulosTitles: (state) => state.permissions.modulosTitles,
      userData: (state) => state.userData.userData,
    }),
    addnotification(){
      return this.grupoEconomico==1 && this.userData.PermissaoAcoes.portal.includes('addnotification') // this.grupoEconomico==1 && 
    },
    updatenotification(){
      return this.grupoEconomico==1 && this.userData.PermissaoAcoes.portal.includes('updatenotification') // this.grupoEconomico==1 &&
    },
  },
  beforeMount() {
    this.modules = this.$store.getters["permissions/getModulosList"]()
  },
  mounted() {
    this.payload = {grupoEconomico:this.grupoEconomico, ...this.pagination }
    this.getNotifications(this.payload).then(() => {
      this.filteredList = this.list
      this.modules = this.$store.getters["permissions/getModulosList"]()
    })
    this.prestadores = this.$store.getters[
      "permissions/getPrestadoresByGeco"
    ]();
  },
  methods: {
     ...mapActions('notifications', ['getNotifications']),
    selectToEditItem(item, showForm) {
      if (!item) return;
      this.editItem = { ...item };
      this.$nextTick(() => (this.showList = showForm ? false : this.showList));
      this.dialog = false
    },
    selectItem(item, bool) {
      this.message = JSON.stringify(item)
      this.selectedItem = item ? Object.assign({}, item) : null;
      if (bool == true) 
        this.dialog = true
    },
    async filterList(formData) {
      this.filter = formData;
      let list = [...this.list];
      let newList = [];
      if (formData && list.length) {
        newList = await list.reduce((arr, item) => {
          let matchPriority = formData.prioridade_alta
            ? item.prioridade_alta == formData.prioridade_alta
            : true;
          let matchModule =
            formData.modulo.toLowerCase() == item.modulo.toLowerCase() ||
            formData.modulo == "";
          let regex = formData.search
            ? new RegExp(formData.search, "gi")
            : null;
          let matchSearch = regex
            ? item.nome.match(regex) != null ||
              item.mensagem.match(regex) != null
            : true;
          if (matchPriority && matchModule && matchSearch) {
            arr.push(item);
          }
          return arr;
        }, []);
      }
      this.filteredList = newList;
      return newList
    },
    // getNotifications(filter) {
    //   this.filter = filter ? filter : null;
    //   if (!this.grupoEconomico) return;
    //   let obj = {
    //     query: [
    //       {
    //         Modulo: "Portal",
    //         Acao: "getnotifications",
    //         Payload: {
    //           grupo_economico: this.grupoEconomico,
    //           readed: null,
    //           prioridade_alta: this.filter ? this.filter.prioridade_alta : null,
    //           modulo: this.filter ? this.filter.modulo : null,
    //           prestador: this.filter ? this.filter.prestador : null,
    //         },
    //       },
    //     ],
    //   };
    //   this.$store.dispatch("request/doRequest", obj).then((response) => {
    //     if (!response || response.isAxiosError || response.error) {
    //       this.$store.commit("hideLoader");
    //       return;
    //     }
    //     this.list = response.dados;
    //     this.newMessagesCount = response.dados
    //       ? response.dados.filter((msg) => !msg.is_readed).length
    //       : null;
    //     this.importantMessagesCount = response.dados.filter(
    //       (msg) => msg.prioridade_alta
    //     ).length;
    //     this.$store.state.newMessagesCount = this.newMessagesCount;
    //   });
    // },
    saveItem(formData) {
      formData.grupo_economico = this.grupoEconomico;
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: formData.id ? "updatenotification" : "addnotification",
            Payload: formData,
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getNotifications(this.payload);
            this.showList = true;
          },
          btConfirm: { name: "Ok", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    deleteNotification(id) {
      let obj = {
        query: [
          {
            Modulo: "Base",
            Acao: "deletenotification",
            Payload: {
              Id: id,
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        this.list = response.data;
      });
    },
    readedNotification(item) {
      if (!item.id) {
        return;
      }
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "readednotification",
            Payload: {
              grupo_economico: this.grupoEconomico,
              id: item.id,
            },
          },
        ],
      };

      this.$store.dispatch("request/doRequest", obj).then(() => {
        item.is_readed = true;
        //CORRIGIR!!! this.list = response.data
      });
    },
  },
};
</script>

<style>
</style>
